module.exports = __webpack_public_path__ + "img/css-bg.7290cda2.png";